import { ChangeStoreStyleTokens } from "./changeStore.tokens";

export const ChangeStoreStyles: ChangeStoreStyleTokens = {
    confirmButton: {
        color: "success"
    }
};
